/* Fiocco Nero site helpers (working copy). */
(function () {
  // Mobile: hide the floating call button while the add-to-cart button is on screen, so it never covers it.
  function callButtonGuard() {
    var call = document.querySelector('.mobile-icon');
    if (!call || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.ProductForm__AddToCart, .Cart__Checkout, button[name="checkout"], .shopify-payment-button');
    if (!targets.length) return;
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
      call.classList.toggle('fn-call-hidden', visible.size > 0);
    }, { rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callButtonGuard); else callButtonGuard();
})();
